import { useSyncExternalStore } from "use-sync-external-store/shim";

import { connect, disconnect, getSnapshot, subscribe } from "./store";

export const useQZTray = () => {
  const state = useSyncExternalStore(subscribe, getSnapshot);

  return {
    ...state,
    connect,
    disconnect,
  };
};
